import PostsRepository from './postsRepository'
import CircleRepository from './circleRepository'
import QARepository from './qaRepository'
import UserRepository from './userRepository'
import AppRepository from './appRepository'
import ResourceRepository from './resourceRepository'
import AboutCircleRepository from './aboutCircleRepository'
import ReviewsRepository from './reviewsRepository'
import LeaveCircleRepository from './leaveCircleRepository'
import MedicalDirectoryRepository from './medicalDirectoryRepository'

const repositories = {
  posts: PostsRepository,
  circle: CircleRepository,
  qa: QARepository,
  user: UserRepository,
  app: AppRepository,
  resource: ResourceRepository,
  aboutCircle : AboutCircleRepository,
  reviews : ReviewsRepository,
  leaveCircle : LeaveCircleRepository,
  medicaldirectory : MedicalDirectoryRepository
}

export const RepositoryFactory = {
  get: name => repositories[name]
}



// WEBPACK FOOTER //
// ./src/repositories/RepositoryFactory.js